export const getOrderClass = (order?: number): string => {
  switch (order) {
    case 1:
      return "order-1"
    case 2:
      return "order-2"
    case 3:
      return "order-3"
    case 4:
      return "order-4"
    case 5:
      return "order-5"
    default:
      return "order-6"
  }
}
